<template>
  <div>
    <div>
      <font-awesome-icon
        :icon="['fas', 'pencil']"
        class="text-sky-900"
        @click="openModal"
      />
    </div>

    <TransitionRoot appear :show="isOpen" as="template">
      <Dialog as="div" @close="closeModal" class="relative z-10">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-black/25" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
          <div
            class="flex min-h-full items-center justify-center p-4 text-center"
          >
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <DialogPanel
                class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
              >
                <DialogTitle
                  as="h3"
                  class="text-lg font-medium leading-6 text-gray-900 uppercase flex justify-center"
                >
                  Edit Vehicle Check
                </DialogTitle>
                <form @submit.prevent="editVehicleCheck">
                  <div class="mb-4 font-inter mt-10">
                    <div>
                      <label for="make" class="block text-black text-sm mb-2"
                        >Inspection Check Name</label
                      >
                      <textarea
                        v-model="vehicleCheckArray.Check"
                        type="text"
                        id="make"
                        name="make"
                        class="border w-full focus:outline-none focus:ring-2 focus:ring-orange-400 rounded py-1 px-2"
                        required
                      />
                    </div>
                  </div>

                  <!-- cancel form input-->
                  <div class="flex justify-between mt-8">
                    <p
                      @click="closeModal"
                      class="bg-red-600 text-white py-2 px-4 rounded"
                    >
                      Cancel
                    </p>
                    <button
                      v-if="!isUpdating"
                      type="submit"
                      class="bg-orange-600 text-white py-2 px-4 rounded"
                    >
                      Edit
                    </button>
                    <div v-else>
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-orange-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  </div>
                </form>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
</script>
<script>
import DataRepository from "@/infrastructure/services/DataRepository";
export default {
  props: {
    vehicleCheck: {
      required: true,
      default: [],
    },
  },
  data() {
    return {
      isUpdating: false,
      isOpen: false,
      vehicleCheckArray: {
        Check: this.vehicleCheck.Check,
        EditedBy: this.$store.getters.getUserData.id,
        EditedAt: this.$store.getters.getCurrentTimestampZDate,
      },
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
    },
    openModal() {
      this.isOpen = true;
    },
    async editVehicleCheck() {
      this.isUpdating = true;
      const response = await DataRepository.editVehicleCheck(
        this.vehicleCheckArray,
        this.vehicleCheck.CheckID
      );
      this.$emit("edited", response);
      this.closeModal();
      this.isUpdating = false;
    },
  },
};
</script>
